import React from 'react'
import { Link } from 'react-router-dom'
import { IdentificationIcon, CameraIcon, ShieldCheckIcon, BoltIcon } from '@heroicons/react/24/outline'
import { BRAND_NAME } from '../../config/brand'
import { DashRoot } from './primitives'
import './dashboard.css'

const FEATURES = [
  { label: 'Documents', title: 'ID & passport OCR', icon: <IdentificationIcon /> },
  { label: 'Liveness', title: 'Selfie + face match', icon: <CameraIcon /> },
  { label: 'Screening', title: 'AML & duplicates', icon: <ShieldCheckIcon /> },
  { label: 'Webhooks', title: 'Real-time events', icon: <BoltIcon /> },
]

/** Split login layout: orange brand panel (folder tiles) + form column. */
export function AuthShell({ eyebrow, headline, blurb, children }: { eyebrow: string; headline: React.ReactNode; blurb: React.ReactNode; children: React.ReactNode }) {
  return (
    <DashRoot>
      <div className="sf-auth">
        <section className="sf-auth-art" aria-hidden="false">
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Link to="/" style={{ display: 'inline-flex', background: '#fff', borderRadius: 999, padding: '8px 16px' }} aria-label={`${BRAND_NAME} home`}>
              <img src="/saflens-logo.png" alt={BRAND_NAME} style={{ height: 22 }} />
            </Link>
            <span className="sf-chip" style={{ background: 'rgba(255,255,255,0.2)', color: '#fff' }}>{eyebrow}</span>
          </div>
          <div>
            <h2>{headline}</h2>
            <p>{blurb}</p>
          </div>
          <div className="sf-auth-folders">
            {FEATURES.map((f, i) => (
              <div className="sf-folder-wrap" key={f.label} style={{ filter: 'none', paddingTop: 30 }}>
                <div className={`sf-folder ${i === 0 ? 'white' : ''}`} style={i === 0 ? undefined : ({ ['--folder-bg' as any]: '#fb8b3f', color: '#fff' } as React.CSSProperties)}>
                  <div className="sf-folder-label" style={i === 0 ? undefined : { color: 'rgba(255,255,255,0.85)' }}>{f.label}</div>
                  <div className="sf-folder-mid" style={{ minHeight: 48 }}>
                    <span className="sf-roundicon" style={i === 0 ? { background: 'var(--sf-accent-pale)', color: 'var(--sf-accent-deep)' } : { background: 'rgba(255,255,255,0.2)', color: '#fff' }}>{f.icon}</span>
                  </div>
                  <div style={{ fontWeight: 600, fontSize: 15 }}>{f.title}</div>
                </div>
              </div>
            ))}
          </div>
        </section>
        <section className="sf-auth-form">
          <div className="sf-auth-card">{children}</div>
        </section>
      </div>
    </DashRoot>
  )
}
